//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default { 
    components: {
        
    },   
    data() {
        return {
            fromData:{
                name:'',
                phone:'',
                store: '',
                address:'',
            },
        }
    },
    created(){
       
    },
    methods: {
        submit() {
            let that = this;
            if(!this.fromData.name){
                that.$func.showToast('请输入您的姓名');
                return false;
            }
            const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
            if (!this.fromData.phone || !reg.test(this.fromData.phone)) {
                that.$func.showToast('请输入您的手机号');
                return false;
            }
            // if(!this.fromData.store){
            //     that.$func.showToast('请输入门店名称');
            //     return false;
            // }
            this.$api.storeApply(that.fromData).then((res)=>{
                if(res){
                    that.$func.showToast('提交成功');
                    that.fromData.name = '';
                    that.fromData.phone = '';
                    that.fromData.store = '';
                    that.fromData.address = '';
                }
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/pages/storeApply.vue